import React from 'react'
import {
    FaPython,
    FaReact,
    FaJava,
} from "react-icons/fa";

import { SiJavascript } from "react-icons/si";

export const skill = [
    {
        id: 1,
        icon: < FaPython color="#4B8BBE" />,
        name: 'Python',
    },
    {
        id: 2,
        icon: < FaJava color="#4B8BBE" />,
        name: 'Java',
    },
    {
        id: 3,
        icon: < FaReact color="#61DBFB" />,
        name: 'React',
    },
    {
        id: 4,
        icon: < SiJavascript color="yellow" />,
        name: 'JavaScript',
    },
];